import { render, staticRenderFns } from "./MemberOrdersBoard.vue?vue&type=template&id=e594adf8"
import script from "./MemberOrdersBoard.vue?vue&type=script&lang=js"
export * from "./MemberOrdersBoard.vue?vue&type=script&lang=js"
import style0 from "./MemberOrdersBoard.vue?vue&type=style&index=0&id=e594adf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports